import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import {
  CreateUpdateExternalReferralDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { ExternalReferral } from '../../components/ExternalReferral/ExternaReferral';
import { newExternalReferral } from '../../../common/spdCore/contexts/ExternalReferralContext';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
export const GenerateExternalReferralView: React.FC = () => {
  const spd = useSpdCore();
  const [title, setTitle] = useState<string | undefined>(
    `Generowanie skierowania`,
  );
  const [initialReferral] = useState(newExternalReferral);

  useEffect(() => {
    spd.companies
      .getMines()
      .then(companies => {
        setTitle(
          `Generowanie skierowania (${companies
            .map(c => c.officialName || c.name)
            .filter(Boolean)
            .join(', ')})`,
        );
      })
      .catch(() => {
        setTitle('Generowanie skierowania');
        console.log('Nie udało się pobrać firm');
      });
  }, [spd.companies]);

  const onSave = async (externalReferral: CreateUpdateExternalReferralDto) => {
    try {
      await spd.externalReferrals.create(externalReferral);
      return {
        saved: true,
        errors: [],
      };
    } catch (response) {
      return {
        saved: false,
        errors: await responseErrors(response as ResponseError),
      };
    }
  };

  return (
    <Card>
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <ExternalReferral externalReferral={initialReferral} onSave={onSave} />
      </Card.Body>
    </Card>
  );
};
